export default "/imgs/investigation-01.png"